import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as LayerIcon } from './icons/layers.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ActivityEventTrackMode, LayerMergedEvent } from './Types'
import { pluralize } from 'utils'
import { ProseDisplay } from 'common/ProseInput/ProseDisplay'
import { LayerSummary } from 'types'
import { TimelineEventInitiator } from 'screens/Activity/Types'

interface Props extends ActivityEventPosition {
  event: LayerMergedEvent
}

interface ContentProps {
  user: TimelineEventInitiator
  layer: LayerSummary
  data: LayerMergedEvent['data']
}

const Content = ({ layer, data, user }: ContentProps) => {
  const isCurrentLayer = data.merged_layer_id === layer.id

  if (isCurrentLayer) {
    return (
      <>
        <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> merged this layer
      </>
    )
  }

  return (
    <>
      <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> merged {data.merged_layer_name}{' '}
      with {data.tracked_changes_count} tracked {pluralize('change', data.tracked_changes_count)} and{' '}
      {data.comments_count} {pluralize('comment', data.comments_count)}
    </>
  )
}

const LayerMerged = ({ event, ...props }: Props) => {
  const { user, data, layer } = event

  return (
    <BaseActivityEvent
      {...props}
      icon={<LayerIcon style={{ color: data.merged_layer_color }} />}
      trackMode={ActivityEventTrackMode.Merge}
      timestamp={event.timestamp}
      message={data.note && <ProseDisplay html={data.note} />}
      content={<Content layer={layer} data={data} user={user} />}
    />
  )
}

export { LayerMerged }
